import { ABOUT_THE_COMPANY } from '../../../lib/utils/message'
import { CMSOpportunityDetailsType, CMSSectionBase } from '../../../lib/types'

export type CMSSectionKey = keyof CMSOpportunityDetailsType

export type CMSSectionMeta = {
  defaultTitle: string
  id: string
  titleTestId: string
  usesOwnShell?: boolean
}

export const CMS_SECTION_META: Partial<Record<CMSSectionKey, CMSSectionMeta>> = {
  about: {
    defaultTitle: ABOUT_THE_COMPANY,
    id: 'about-company',
    titleTestId: 'cms-about-company',
  },
  executiveSummary: {
    defaultTitle: 'Executive Summary',
    id: 'executive-summary',
    titleTestId: 'cms-executive-summary',
  },
  strengths: {
    defaultTitle: 'Strengths',
    id: 'strengths',
    titleTestId: 'cms-strengths',
  },
  competitiveAdvantage: {
    defaultTitle: 'Competitive Advantage',
    id: 'competitive-advantage',
    titleTestId: 'cms-competitive-advantage',
  },
  additionalSections: {
    defaultTitle: '',
    id: 'additional-sections',
    titleTestId: 'cms-additional-sections-heading',
    usesOwnShell: true,
  },
  whyShouldYouInvest: {
    defaultTitle: 'Why Should You Invest?',
    id: 'why-should-you-invest',
    titleTestId: 'cms-why-should-you-invest',
  },
  sourceCountries: {
    defaultTitle: 'Source Countries',
    id: 'source-countries',
    titleTestId: 'cms-source-countries',
  },
  riskManagement: {
    defaultTitle: 'Risk Management',
    id: 'risk-management',
    titleTestId: 'cms-risk-management',
  },
  aboutFund: {
    defaultTitle: 'About the Fund',
    id: 'about-fund',
    titleTestId: 'cms-about-fund',
  },
  regulation: {
    defaultTitle: 'Regulation',
    id: 'regulation',
    titleTestId: 'cms-regulation',
  },
  factSheet: {
    defaultTitle: 'Fact Sheet',
    id: 'fact-sheet',
    titleTestId: 'cms-fact-sheet',
  },
  process: {
    defaultTitle: 'Process',
    id: 'process',
    titleTestId: 'cms-process',
  },
  opportunityImages: {
    defaultTitle: 'Opportunity images',
    id: 'opportunity-images',
    titleTestId: 'cms-opportunity-images-heading',
  },
  opportunityVideos: {
    defaultTitle: 'Opportunity Videos',
    id: 'opportunity-videos',
    titleTestId: 'cms-opportunity-videos',
  },
  keyPartnerships: {
    defaultTitle: 'Key Partnerships',
    id: 'key-partnerships',
    titleTestId: 'cms-key-partnerships',
  },
  clientBase: {
    defaultTitle: 'Client Base',
    id: 'client-base',
    titleTestId: 'cms-client-base',
  },
  leadershipTeam: {
    defaultTitle: 'Team',
    id: 'leadership-team',
    titleTestId: 'cms-leadership-team',
  },
  risksInvolved: {
    defaultTitle: 'Risk Involved',
    id: 'risks-involved',
    titleTestId: 'cms-risks-involved',
  },
}

export const getCMSSectionTitle = (
  key: CMSSectionKey,
  sectionData?: CMSSectionBase & { sectionTitle?: string },
): string => {
  const meta = CMS_SECTION_META[key]
  if (!meta) {
    return sectionData?.header?.trim() || ''
  }

  if (key === 'clientBase' || key === 'leadershipTeam') {
    return sectionData?.header?.trim() || sectionData?.sectionTitle?.trim() || meta.defaultTitle
  }

  if (key === 'about') {
    const header = sectionData?.header?.trim()
    if (header && header.toLowerCase() !== 'highlights') {
      return header
    }
    return meta.defaultTitle
  }

  const resolved = sectionData?.header?.trim() || meta.defaultTitle
  return resolved?.trim() || 'Details'
}
